(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@normy/core"));
	else if(typeof define === 'function' && define.amd)
		define(["@normy/core"], factory);
	else if(typeof exports === 'object')
		exports["NormyQueryCore"] = factory(require("@normy/core"));
	else
		root["NormyQueryCore"] = factory(root["Normy"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__700__) => {
return 